import PropTypes from 'prop-types'
import { Text } from '@theneatcompany/nui'

const FieldCounter = ({ value, maxLength }) => (
  <Text size="xsmall" className="pt-form-counter" data-cy="field-counter">
    {value}/{maxLength}
  </Text>
)

FieldCounter.propTypes = {
  value: PropTypes.number.isRequired,
  maxLength: PropTypes.number.isRequired,
}

export default FieldCounter
